<div class="modal-header">
  <h5 class="modal-title mb-0">Copy campaign</h5>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <app-sb-input-form
    mode="add"
    title="Copy campaign"
    submitLabel="Save"
    [showHeader]="false"
    [embedded]="true"
    (submitted)="saveProject()"
    (cancelled)="modal.dismiss('cancel')">
    <div class="form-wraper" *ngIf="campaignForm" [formGroup]="campaignForm">
      <div class="row">
        <div class="col-md-12 mb-3">
          <label class="form-label">Campaign name <span class="text-danger">*</span></label>
          <input
            class="form-control"
            placeholder="Campaign name"
            type="text"
            formControlName="name"
            ngbAutofocus
            [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
          >
          <div class="invalid-feedback d-block" *ngIf="submitted && f.name.errors?.required">
            Campaign name is required
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <label class="form-label">Project <span class="text-danger">*</span></label>
          <app-auto-complete-select
            [hideLabel]="true"
            [isCreatable]="false"
            [onlyBottomBorder]="false"
            [placeholder]="'Select Project'"
            [selectOptions]="projects"
            [labelKey] = "'title'"
            (searchValue)="handleSearchValue($event)"
            (optionSelected)="handleProjectSelection($event)"
            [(selectedValue)]="projectId"
          ></app-auto-complete-select>
          <div class="invalid-feedback d-block" *ngIf="submitted && f.project_id.errors?.required">
            Project is required
          </div>
        </div>
        <div class="col-md-12 customize-email d-flex align-items-center">
          <input id="with_influencers" placeholder="" type="checkbox" formControlName="with_influencers">
          <label for="with_influencers" class="mb-0">Same influencer type and segment</label>
        </div>
      </div>
    </div>
  </app-sb-input-form>
</div>
